import React from "react";
import { useMessageSource } from "react-message-source";
import {
  InsurancePlusIcon,
  InvoicingTypeIcon,
} from "../../../../../ui/widgets/icons";
import { DashboardCardApplicationDocument } from "../../../../../api/commercial/generated-types";
import useInsurancePlus from "../../../../shared/hooks/useInsurancePlus";

interface AdditionalInfoProps {
  cardApplication: DashboardCardApplicationDocument;
}

export const AdditionalInfoDialog = ({
  cardApplication,
}: AdditionalInfoProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const { hasDecentralizedInvoicing } = cardApplication;
  const { hasInsurancePlus } = useInsurancePlus();

  const decentralizedInvoicing = () => {
    const invoicingTypeKey = hasDecentralizedInvoicing
      ? "Dashboard.cardholderApplicationApplied.AdditionalInfo.decentralizedInvoicing.text"
      : "Dashboard.cardholderApplicationApplied.AdditionalInfo.centralizedInvoicing.text";

    return (
      hasDecentralizedInvoicing !== null && (
        <div className="scd-more-table-item">
          <InvoicingTypeIcon
            hasDecentralizedInvoicing={hasDecentralizedInvoicing}
          />
          <span className="item-text">{getMessage(invoicingTypeKey)}</span>
        </div>
      )
    );
  };

  const insurancePlus = () => {
    return (
      hasInsurancePlus && (
        <div className="scd-more-table-item">
          <InsurancePlusIcon />
          <span className="item-text">
            {getMessage(
              `Dashboard.cardholderApplicationApplied.AdditionalInfoDialog.insurancePlus.text`,
            )}
          </span>
        </div>
      )
    );
  };

  return (
    <>
      {insurancePlus()}
      {decentralizedInvoicing()}
    </>
  );
};
